/*//////////////////////*/
/* Imports
/*/ /////////////////////*/
import { useEffect, useRef, useState, useMemo } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getContentReducer } from "../../store/content/content.selector";
import { getProgrammeReducer } from "../../store/programme/programme.selector";
import { CheckedIcon } from "../../icons/Checked.icon";
import { getAuthReducer } from "../../store/auth/auth.selector";
import {
  setSocketsSearchImagesVisible,
  setSocketsSearchImagesColors,
  setSocketsSearchSelected,
  setSocketsSearchSelectedGroup,
} from "../../utils/websockets.utils";

import BackButton from "../../components/BackButton/BackButton.component";
import SearchButton from "../../components/SearchButton/SearchButton.component";
import Empty from "../../components/Empty/Empty.component";
import Lot from "../../components/Lot/Lot.component";

import "../../components/Lot/Lot.styles.scss";


import {getScale} from "../../utils/helpers.utils";
import {getProjectsReducer} from "../../store/projects/projects.selector";



const Results = ({ socket }) => {


  // Properties
  const { socketID } = useSelector(getAuthReducer);
  const selectedLotsRef = useRef([]);
  const { search } = useLocation();
  const { programmeDatas, errorLots, errorDatas } = useSelector(getProgrammeReducer);
  const { projectID, scaleID } = useParams();
  const {
        texts: {
          searchNew,
          searchNull,
          searchQuantity,
          searchAll,
          videoEmpty,
          apiError,
        },
      } = useSelector(getContentReducer);
  const projectsReducer = useSelector(getProjectsReducer);
  const [searchParams] = useSearchParams();
  const scale = useMemo(
    () => getScale(projectsReducer, projectID, scaleID),
    [projectID, scaleID, projectsReducer]
  );
  const [isError, setIsError] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [filters, setFilters] = useState();
  const [lots, setLots] = useState(); // liste complete des lots
  const [groups, setGroups] = useState(); // liste complete des lots
  const [filteredLots, setFilteredLots] = useState(); // liste filtre des lots
  const [ecranLot, setEcranLot] = useState(null);
  const [ecranGroup, setEcranGroup] = useState(null);
  const [selectedLots, _setSelectedLots] = useState([]);
  const [selectedLotsDatas, _setSelectedLotsDatas] = useState([]);
  const socketsReady = useRef(false);




  // Functions
  const videoRemote = ({ exists }) => {
    if (!exists) setIsError(videoEmpty);
  };

  const getLotDatas = () => { // recuperation des donnees de lot a partir des csv strapi
    // Liste des filtres
    fetch(`https://strapi-tzjc.onrender.com${scale?.lotsFilters?.data?.attributes?.url}`)
    .then(response => response.text())
    .then(csv => {
      const legendsCSV = csv.split("\r\n")[0].split(",")
      const parsedCSV = csv.split("\r\n").slice(1).map(v => v.split(","))

      const legendsDatas = []

      parsedCSV.map(legend => {
        const legendDatas = {}

        legendsCSV.map((v, i) => {
          legendDatas[v] = i !== 2 ? legend[i] : legend[i].split("|").map(option => { return {value : option, label : option}})
        })

        legendsDatas.push(legendDatas)
      })

      setFilters(legendsDatas)
    })

    // Liste des lots
    fetch(`https://strapi-tzjc.onrender.com${scale?.lotsList?.data?.attributes?.url}`)
    .then(response => response.text())
    .then(csv => {
      const legendsCSV = csv.split("\r\n")[0].split(",")
      const parsedCSV = csv.split("\r\n").slice(1).map(v => v.split(","))
      
      const lotsDatas = []

      parsedCSV.map(lot => {
        const lotDatas = {}

        legendsCSV.map((v, i) => {
          lotDatas[v] = lot[i]
        })

        lotsDatas.push(lotDatas)
      })
     
      setLots(lotsDatas)
    })
    
    // Liste des groupes 
    fetch(`https://strapi-tzjc.onrender.com${scale?.groupColors?.data?.attributes?.url}`)
    .then(response => response.text())
    .then(csv => {
      const legendsCSV = csv.split("\r\n")[0].split(",")
      const parsedCSV = csv.split("\r\n").slice(1).map(v => v.split(","))
      
      const groupsDatas = []

      parsedCSV.map(group => {
        const groupDatas = {}

        legendsCSV.map((v, i) => {
          groupDatas[v] = group[i]
        })

        groupsDatas.push(groupDatas)
      })
     
      setGroups(groupsDatas)
    })

  }

  const allClick = () => { // selection de l'ensemble des lots
    setAllChecked(!allChecked);
  }

  const updateEcranLot = (lotName, selected) => {
    setEcranLot(selected ? lotName : null);
  };

  const udpdateEcranGroup = (lotName, selected) => {
    setEcranGroup(selected ? lotName : null);
  };


  const setSelectedLots = (data) => {
    selectedLotsRef.current = data;
    _setSelectedLots(data);
    _setSelectedLotsDatas(data.map(lot => {
      const finded = lots.find(x => x.nom === lot)
      return {"color" : finded.couleur, "saturation" : finded.saturation}
    }))
  };

  const updateSelectedLots = (lotName, checked) => {
    setSelectedLots(
      checked
        ? [...selectedLotsRef.current, lotName]
        : selectedLotsRef.current.filter((lot) => lot !== lotName)
    );
  };

  
  const getFilteredLots = (lots, infos, filters) => {
    for (const filter of filters) {


      if (infos[filter.nom] || infos[`min${filter.nom}`] || infos[`max${filter.nom}`]) {

        if (filter.type === "range") {
          // filtre min
          if (infos[`min${filter.nom}`]) {
            lots = lots.filter((lot) => parseFloat(lot[filter.nom]) >= infos[`min${filter.nom}`]);
          }
          // filtre max
          if (infos[`max${filter.nom}`]) {
            lots = lots.filter((lot) => parseFloat(lot[filter.nom]) <= infos[`max${filter.nom}`]);
          }
        }

        if (filter.type === "multiselect") {
          lots = lots.filter((lot) => infos[filter.nom].split(",").includes(lot[filter.nom]));
        }
      }
    }

    return lots;
  }


  // Effects
  useEffect(() => {
    if (socket && !socketsReady.current) {
      socket.on("videoRemote", videoRemote);
      socketsReady.current = true;
    }
    return () => {
      if (socket) socket.off("videoRemote", videoRemote);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  useEffect(() => {
    if (selectedLots && socketID) {
      setSocketsSearchImagesVisible(selectedLots, socketID);
      setSocketsSearchImagesColors(selectedLotsDatas.map(x => x.color), selectedLotsDatas.map(x => x.saturation), socketID);
    }
    return () => {
      if (socketID) {
        setSocketsSearchImagesVisible([], socketID);
        setSocketsSearchImagesColors([], [], socketID);
      }
      
    };
  }, [selectedLots, selectedLotsDatas, socketID]);

  useEffect(() => {
    if (ecranLot && socketID) {
      setSocketsSearchSelected(`${ecranLot}`, socketID);
    }
    return () => {
      if (socketID) setSocketsSearchSelected("", socketID);
    };
  }, [ecranLot, socketID]);

  useEffect(() => {
    if (ecranGroup && socketID) {
      const color = groups.find(x => x.nom === ecranGroup)?.couleur
      setSocketsSearchSelectedGroup(`${ecranGroup}`, `${color}`, socketID);
    }
    return () => {
      if (socketID) setSocketsSearchSelectedGroup("", "", socketID);
    };
  }, [ecranGroup, socketID]);
  
  useEffect(() => {
    if (scale && scale?.lotsList?.data?.attributes?.url) {
        getLotDatas()
      }
  }, [scale])

    useEffect(() => {
      if (lots && filters) {
        const search = Object.fromEntries(searchParams.entries());
        setFilteredLots(getFilteredLots(lots, search, filters))
      }
  }, [lots, filters, searchParams]);

  useEffect(() => {
    if (filteredLots && programmeDatas && programmeDatas?.nom) {
      setSelectedLots(filteredLots.map((filteredLot) => filteredLot.nom));
    }
  }, [filteredLots, programmeDatas]);

  useEffect(() => {
    setSelectedLots(
      allChecked ? filteredLots.map((filteredLot) => filteredLot.nom) : []
    );
  }, [allChecked, filteredLots]);


  // Render
  return (
    filteredLots &&
      <>

        <BackButton
          text={`${filteredLots.length} ${searchQuantity}`}
          link={`/project/${projectID}/scale/${scaleID}/search/form${search}${window?.location?.search}`}
        />

        <div className="results | mb-6 px-1">
          {!lots.length ?
            <p className="text-center">{searchNull}</p>
            :
            <>
              <div onClick={allClick} className="lot | mb-3 p-3">
                <div className="lot__body">
                  <CheckedIcon checked={allChecked} />
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={() => {}}
                  />
                  <div>{searchAll}</div>
                </div>
              </div>

              <ul className="grid md:grid-cols-3 gap-3">
                {filteredLots.map((lot) => (
                  <li key={lot["Nom"]}>
                    <Lot
                      lot={lot}
                      allChecked={allChecked}
                      ecranLot={ecranLot}
                      ecranGroup={ecranGroup}
                      updateEcranLot={updateEcranLot}
                      udpdateEcranGroup={udpdateEcranGroup}
                      updateSelectedLots={updateSelectedLots}
                      // programmeDatas={programmeDatas}
                      projectID={projectID}
                      scaleID={scaleID}
                    />
                  </li>
                ))}
              </ul>
            </>
          }
        </div>

        <SearchButton projectID={projectID} scaleID={scaleID} />
      </>
  )
}

export default Results;
